/** Escopo de linhas da exportação; espelha `ExportScopeType` do backend. Ausente no pedido vale `ALL`. */
export enum ExportScopeType {
  /** Todas as páginas do filtro. */
  ALL = 'ALL',
  /** A página visível: usa `page` e `per_page` da consulta. */
  PAGE = 'PAGE',
  /** As linhas marcadas, de qualquer página: usa `ids` da consulta. */
  SELECTED = 'SELECTED',
}
